module.exports = __webpack_public_path__ + "static/media/7.c53b2f4a.jpg";